import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  extractNumbers,
  getselectedIds,
  isEmptyObject,
  MakeAxiosRequest,
} from "../../../utils/handler";
import { phoneRegex } from "../../../Constants";
import { useDispatch } from "react-redux";
import FormFields from "../../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import { updateProfile } from "../../../features/authSlice";
import NewRelationship from "./../NewRelationship";
import { InfoModal } from "../../../Components/modals/InfoModal";
import Loader from "../../../Components/loader/Loader";
import UpdateInfoLayout from "./UpdateInfoLayout";

function HomeInformation(props) {
  const {
    showModal,
    closeModal,
    editKey,
    listingFn,
    profileEdit,
    getResponse,
    updateBillingInfo,
    showMoreInfo = false,
    isMaxineStar = false,
    handleBack,
  } = props;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, reset, setValue, watch, trigger, getValues, control } =
    methods;
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);

  const [prefillDetails, setPrefillDetails] = useState([]);
  const [optionsList, setOptionsList] = useState({
    relations: [],
    proxyType: [],
    additionalNeed: [],
    states: [],
    responsiblePartyList: [],
    otherRelation: [],
  });

  // const [responsiblePartyOther, setResponsiblePartyOther] = useState({});

  // const submitUrl =  profileEdit ? '/updateprofile' : (editKey ? '/updateproxy' : '/saveproxy');
  const submitUrl = profileEdit
    ? "/updateaditionalcustomerdetails"
    : "/updateaditionalrelationdetails";

  const fetchData = async () => {
    try {
      const statesList = await MakeAxiosRequest("post", "/getstates");
      const createproxyinfo = await MakeAxiosRequest(
        "post",
        "/createproxyinfo"
      );
      if (!profileEdit && editKey) {
        const edit = await MakeAxiosRequest(
          "post",
          "/getaditionalrelationdetails",
          { user_proxy_key: editKey, type: "home_information" }
        );
        setPrefillDetails({ ...edit.data.relationDetails });
      } else if (profileEdit) {
        const profile = await MakeAxiosRequest("post", "/getaditionalcustomerdetails",{ type: "home_information" });;
        setPrefillDetails({...profile.data.customerDetails});
      }

      const householdMembers = createproxyinfo.data.household_members?.map(
        (item) => ({
          id: item,
          name: item,
        })
      );
      const houseTypes = createproxyinfo.data.house_types?.map((item) => ({
        id: item.id,
        name: item.type,
      }));
      const pets = createproxyinfo.data.pets?.map((item) => ({
        id: item.id,
        name: item.pet_type,
      }));

      setOptionsList({ householdMembers, houseTypes, pets });
      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  useEffect(() => {
    setSubmitDisabled(false);
    reset({
      peoples_in_house_hold: prefillDetails.peoples_in_house_hold || "",
      home_type_id: prefillDetails.home_type_id || "",
      pet_id: prefillDetails.pet_id || "",
    });
  }, [prefillDetails]);

  const submitData = async (data) => {
    console.log(data);
    // return;
    setSubmitDisabled(true);
    if (updateBillingInfo) {
      updateBillingInfo(data);
    } else {
      try {
        data.state = data.state_id;
        data.responsible_party_phone = extractNumbers(
          data.responsible_party_phone
        );
        const response = await MakeAxiosRequest("post", submitUrl, {
          ...data,
          user_proxy_key: editKey,
          type: "home_information",
        });
        // console.log(response);
        if (response.status == 1) {
          // getResponse && getResponse(response.data,(profileEdit ? 'profile' : (editKey ? 'update' : 'create')))
          reset();
          handleBack ? handleBack() : closeModal();
          listingFn && listingFn();
          // if(response.data?.msg_key =='subText'){
          //   SwalSuccess({subText: response.data?.message, showbtn:true})
          // }else{
          SwalSuccess({ msg: response.message });
          // }
          // profileEdit && dispatch(updateProfile());
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    setSubmitDisabled(false);
  };

  const fields = [
    {
      name: "peoples_in_house_hold",
      label: "How many peoples are in the household?",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select an option" },
      type: "select",
      options: optionsList.householdMembers,
      isShow: true,
    },
    {
      name: "home_type_id",
      label: "Home Type",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select an option" },
      type: "select",
      options: optionsList.houseTypes,
      isShow: true,
    },
    {
      name: "pet_id",
      label: "Pets",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select an option" },
      type: "select",
      options: optionsList.pets,
      isShow: true,
    },
  ];

  if (isLoading) return <Loader />;
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitData)}>
          <UpdateInfoLayout
            title="Home Information"
            handleBack={handleBack}
            isSubmitDisabled={isSubmitDisabled}
          >
            <FormFields fields={fields} />
          </UpdateInfoLayout>
        </form>
      </FormProvider>
    </>
  );
}

export default HomeInformation;
